import React, { useContext, useEffect, useState } from 'react'
import getActualsForUserNew from 'Actuals/use-cases/get-actuals-for-user-new'
import AppContext from '../../../context/AppContext'
import LoadingSpinner from '../../../components/common/LoadingSpinner'

import UsageTree from '../../../Actuals/components/usage-tree/UsageTree'
import getAccountsMap from 'Summary/use-cases/get-accounts-map'

const MonthlyAllocation = () => {
  const { repoFactory, selectedYear } = useContext(AppContext)
  const [isLoading, setIsLoading] = useState(false)
  const [actualsData, setActualsData] = useState(null)
  const [accounts, setAccounts] = useState(null)

  useEffect(() => {
    getAccountsMap({
      accountMapperRepo: repoFactory.accountMapperRepoNew(),
      observer: {
        errorReceivingAccounts: () => {},
        receiveAccounts: (response) => {
          setAccounts(response)
        }
      }
    })
  }, [repoFactory, setAccounts])

  useEffect(() => {
    setIsLoading(true)
    getActualsForUserNew(
      {
        year: selectedYear,
        token: localStorage.getItem('authToken')
      },
      {
        actualsRepo: repoFactory.actualsRepo(),
        observer: {
          receiveActuals: ({ actuals }) => {
            setActualsData(actuals)
            setIsLoading(false)
          },
          errorReceivingActuals: () => {
            setIsLoading(false)
            setActualsData(null)
          }
        }
      }
    )
  }, [selectedYear, repoFactory, setActualsData, setIsLoading])

  return (
    <div className="actuals-data">
      {isLoading && <LoadingSpinner />}
      {actualsData && <UsageTree actualsData={actualsData} year={selectedYear} accountsData={accounts} />}
    </div>
  )
}

export default MonthlyAllocation
